import React from 'react';

const TokenContext = React.createContext();
export default TokenContext;
